module.exports = __webpack_public_path__ + "ffcc050b2d92d4b14a4fcb527ee0bcc8.woff";


//////////////////
// WEBPACK FOOTER
// ./node_modules/typeface-roboto/files/roboto-latin-500italic.woff
// module id = 670
// module chunks = 0